import React from 'react';

const TrustStrip = () => {
  return (
    <section data-testid="trust-strip" className="py-5 bg-[#F5F5F4] border-y border-[#E7E5E4]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3">
          <span className="text-xs text-[#78716C] font-medium uppercase tracking-wider">
            Recognised by
          </span>
          <div className="flex items-center gap-6">
            <a
              href="https://t-hub.co"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:opacity-75 transition-opacity"
            >
              <img src="/thub-logo.svg" alt="T-Hub" className="h-8 w-8 object-contain" />
              <div>
                <div className="text-sm font-semibold text-[#1C1917] leading-tight">T-Hub</div>
                <div className="text-xs text-[#78716C]">Hyderabad, Telangana</div>
              </div>
            </a>
            <div className="w-px h-8 bg-[#E7E5E4]" />
            <a
              href="https://www.startupindia.gov.in"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:opacity-75 transition-opacity"
            >
              <img
                src="/dpiit-header.png"
                alt="DPIIT Startup India"
                className="h-7 object-contain"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
